import { useMutation } from '@tanstack/react-query';
import { toggleUserStatus } from "@/api/user"; 
import { ToggleUserStatus, ReturnToggleUserStatus } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useToggleUserStatus(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnToggleUserStatus, Error, ToggleUserStatus>({
    mutationFn: toggleUserStatus,
    onSuccess,
    onError
  });
}